export default __webpack_public_path__ + "static/media/dots.646d773a.svg";